import { useState, useEffect } from "react";
import LiveService from "../services/live.service";
import axiosInstance from "../modules/axiosInstance";
export const UPLOAD_KEY = "uploadId";

export const useLive = () => {
  const [loading, setLoading] = useState(false);
  const [uploadInfo, setUploadInfo] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [error, setError] = useState(null);
  let connectionFlag = false;

  useEffect(() => {
    if (!connectionFlag) {
      const uploadData = localStorage.getItem(UPLOAD_KEY);
      if (uploadData) {
        const parsed = JSON.parse(uploadData);
        checkUploadStatus(parsed.id);
      } else {
        console.info("No hay datos de subida en localStorage");
      }
    }
  }, []);
  const checkUploadStatusLocal = () => {
    const uploadData = localStorage.getItem(UPLOAD_KEY);
    if (uploadData) {
      console.info("sale por aca alguna vez condicion verdaera");
      try {
        const parsed = JSON.parse(uploadData);
        if (parsed.status === "PROGRESSING") {
          setLoading(true);
          console.info("voy a guardar --->", parsed.info);
          setUploadInfo(parsed.info);
          return;
        }
        if (parsed.status === "COMPLETE") {
          localStorage.removeItem(UPLOAD_KEY);
        }
      } catch (err) {
        console.error("Error al parsear uploadId:", err);
      }
    }
    setLoading(false);
    setUploadInfo(null);
  };

  const checkUploadStatus = async (id) => {
    try {
      console.info("---------------checkUploadStatus---------------");
      const res = await axiosInstance.get(`/api/lives/status/${id}`);
      console.info(res.data);
      const { status, info } = res.data;
      localStorage.setItem(UPLOAD_KEY, JSON.stringify({ id, status, info }));
      console.info("voy a guardar --->", info);
      setUploadInfo(info);
    } catch (err) {
      console.info("Error al consultar estado de upload", err);
      setLoading(false);
      setUploadInfo(null);
    }
  };

  const createNewUpload = (info) => {
    const newUploadId = `${Math.random().toString(36).slice(2)}${Date.now()}`;
    localStorage.setItem(
      UPLOAD_KEY,
      JSON.stringify({ id: newUploadId, status: "PROGRESSING", info })
    );
    return newUploadId;
  };

  const upload = async ({ formData, workshop }) => {
    setLoading(true);
    setError(null);
    setUploadProgress(0);

    try {
      let uploadId = null;
      const existingUpload = localStorage.getItem(UPLOAD_KEY);

      if (existingUpload) {
        try {
          const uploadData = JSON.parse(existingUpload);
          if (uploadData.status === "PROGRESSING") {
            setError(
              "Ya hay una transmisión en progreso. Esperá a que termine antes de subir otra."
            );
            setLoading(false);
            setUploadInfo(null);
            return;
          }
          uploadId = createNewUpload();
        } catch {
          uploadId = createNewUpload();
        }
      } else {
        uploadId = createNewUpload();
      }

      const data = new FormData();
      data.append("image", formData.thumbnail);
      data.append("video", formData.video);
      data.append("uploadId", uploadId);
      data.append(
        "data",
        JSON.stringify({
          dateLive: formData.date,
          workshopId: formData.workshop ? formData.workshop : null,
          title: formData.title,
          workshopNumber: workshop ? workshop.workshopNumber : null,
          categoryId: formData.category || null,
          profesionalsIDs:
            formData.profesionals.length > 0 ? formData.profesionals : null,
        })
      );

      connectionFlag = true;
      console.info("voy a guardar --->", data.data);

      setUploadInfo(data.data);
      await LiveService.upload(data, (percent) => {
        setUploadProgress(percent);
      });

      localStorage.setItem(
        UPLOAD_KEY,
        JSON.stringify({ id: uploadId, status: "COMPLETE", info: data.data })
      );
    } catch (err) {
      console.error(err);
      setError("Ocurrió un error durante la subida");
    } finally {
      setLoading(false);
      setUploadInfo(null);
    }
  };

  return {
    uploadInfo,
    upload,
    checkUploadStatus,
    checkUploadStatusLocal,
    loading,
    error,
    uploadProgress,
  };
};
